export default "__VITE_ASSET__lOoFNcyV__"